<template>
    <b-overlay :show="tableLoading" rounded="sm" >
        <b-card class="inner-block fleet-listing">
            <b-card-header>
                <b-row class="mt-2">
                    <!-- <b-col cols="2" md="1" lg="1"
                        class="d-flex align-items-center justify-content-center"><strong>Fleet</strong></b-col>
                    <b-col cols="10" md="11" lg="11" class="d-flex"> -->
                    <b-col cols="12" class="d-flex">
                        <b-input type="text" :placeholder="$translate('search_filter')" v-model="query"></b-input>
                        <b-button id="add-fleet" block variant="primary" v-if="hasPermissionCreate" @click="addVehicle"><img v-b-tooltip.hover
                                :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body class="button-off">
                <b-col class="page-block">
                    <strong>
                        {{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{ pageCount }} {{
                            $translate('total') }}:
                        {{ pagination.total }}
                    </strong>
                </b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table show-empty :empty-text=" $translate('records_not_found')" id="fleetTable" responsive :items="fleet" :fields="fields">
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="row">
                            <b-button id="view-fleet" @click="view(row.item.id)" v-if="hasPermissionView" class="mr-2" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                            :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="customerTable"
                            :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                            align="right"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'fleet-table',
    mixins: [popupMixins, permissionsMixins],
    props: {
        type: {
            type: String,
        },
        title: String,
    },
    data() {
        return {
            query: '',
            tableLoading: false
        }
    },
    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$nameLabel() },
                {
                    key: 'driver', label: this.$translate('driver'), formatter: value =>
                        this.getDriverName(value)
                },
                { key: 'model', label: this.$translate('model') },
                { key: 'registration', label: this.$translate('registration') },
            ]
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        fleet() {
            const fleet = this.$store.state.fleet.items
            console.log('fleet', fleet)
            return fleet
        },
        pagination() {
            return this.$store.state.fleet.pagination || {}
        },
        user() {
            return this.$store.state.user
        },
    },

    watch: {
        fleet: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },

    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },

    methods: {
        getDriverName(officer) {
            if (officer) {
                return (officer.user.first_name + ' ' + officer.user.last_name)
            } else {
                return this.$translate('unassigned')
            }
        },
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        async doSearch() {
            try {
                this.tableLoading = true
                const {
                    pagination: { page },
                    query,
                } = this
                await this.$store.dispatch('fleet/fetch', {
                    query,
                    page,
                })
            } catch (error) {
                console.error('loading error', error)
            }
        },
        view(index) {
            const path = `${this.$route.path}/${index}`
            this.$router.push({ path })
        },
        addVehicle() {
            const id = 0
            this.$router.push({ params: { id }, name: 'viewVehicle' })
        },
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
    },
}
</script>
<style></style>
